// 测评模块
import * as TypesEvaluation from '../types/types_evaluation';
import Vue from 'vue';
// 内容列表，依次是标准教件、知识库、我的题目、上传题目
const ContentList = ['standard', 'knowledgeDB', 'favorites', 'upload'];
export default {
    state: {
        currentContent: 'knowledgeDB', // 当前展示的内容(题目列表)
        standard: { // 标准教件
            knowledgeId: '' // 知识点id
        },
        knowledgeDB: { // 知识库
            knowledgeId: '' // 知识点id
        },
        favorites: { // 我的题目
            favoritesId: '' // 收藏夹id
        },
        list: [], // 测评题目列表
        info: {}, // 测评的基本信息
        referList: [] // 引用作业列表
    },
    mutations: {
        [TypesEvaluation.EVALUATION_SET_CONTENT](state, {name, data, onlyData}) { // 布置作业左侧sidebar控制右侧展示的内容的通用方法
            /**
             * name:当前展示的内容的名字；
             * data:和内容名同名的对象，用于存放相关数据
             * onlyData: 为true时只更新data不更新展示内容
             * 使用例：
             * store.commit('EVALUATION_SET_CONTENT', {name: 'standard', data: {knowledgeId:'123abc'}})
             * 将当前展示内容改为standard（标准教件），将data的值赋值给name同名的数据对象
             */
            if (ContentList.includes(name)) {
                if (!onlyData) {
                    state.currentContent = name;
                }
                if (data) {
                    state[name] = data;
                }
            }
        },
        //
        // 设置筛选条件
        [TypesEvaluation.EVALUATION_SET_SELECT](state, payload) {
            state.selectExamList = payload;
        },
        // 设置测评列表
        [TypesEvaluation.EVALUATION_SET_LIST](state, payload) {
            state.list = payload;
        },
        // 设置测评的基础信息
        [TypesEvaluation.EVALUATION_SET_INFO](state, payload) {
            state.info = payload;
        },
        // 添加测评题目
        [TypesEvaluation.EVALUATION_ADD_QUESTION](state, payload) {
            state.list.push(payload);
        },
        // 移除测评题目
        [TypesEvaluation.EVALUATION_REMOVE_QUESTION](state, payload) {
            let index = state.list.findIndex(item => item.id === payload.id);
            state.list.splice(index, 1);
        },
        // 引用作业
        [TypesEvaluation.EVALUATION_ADD_REFER](state, payload) {
            state.referList.push(payload);
        },
        // 移除引用
        [TypesEvaluation.EVALUATION_REMOVE_REFER](state, payload) {
            let index = state.referList.findIndex(item => item === payload);
            state.referList.splice(index, 1);
        }
    },
    actions: {
        [TypesEvaluation.EVALUATION_GET_LIST](ctx, payload) {
            /**
          * 获取阶段测评题目列表
          * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=357915930#hfsfd-teacher%E9%98%B6%E6%AE%B5%E6%B5%8B%E8%AF%84API-%E8%8E%B7%E5%8F%96%E9%98%B6%E6%AE%B5%E6%B5%8B%E8%AF%84%E9%A2%98%E7%9B%AE%E4%BF%A1%E6%81%AF
          */
            return Vue.http.get(`/v1/stage-evaluation/${payload}/questions`)
                .then(resp => Vue.checkResp(resp))
                .then(data => {
                    let questionList = data.map(item => {
                    // 新增一个_id 统一一下id的类型
                        item.question.id = item.id + '';
                        item.question.fromType = item.type;
                        return item.question;
                    });
                    ctx.commit(TypesEvaluation.EVALUATION_SET_LIST, questionList);
                }).catch(err => {
                    ctx.commit(TypesEvaluation.EVALUATION_SET_LIST, []);
                    throw err;
                });
        },
        // 获取测评的基础信息
        [TypesEvaluation.EVALUATION_GET_INFO](ctx, payload) {
            /**
            *获取阶段测评基本信息
            *http://wiki.iyunxiao.com/pages/viewpage.action?pageId=357915930#hfsfd-teacher%E9%98%B6%E6%AE%B5%E6%B5%8B%E8%AF%84API-%E8%8E%B7%E5%8F%96%E9%98%B6%E6%AE%B5%E6%B5%8B%E8%AF%84%E5%9F%BA%E6%9C%AC%E4%BF%A1%E6%81%AF
            */
            return Vue.http.get(`/v1/stage-evaluation/${payload}/info`)
                .then(resp => Vue.checkResp(resp, {}))
                .then(data => {
                    ctx.commit(TypesEvaluation.EVALUATION_SET_INFO, data);
                }).catch(err => {
                    ctx.commit(TypesEvaluation.EVALUATION_SET_INFO, {});
                    throw err;
                });
        },
        // 更新测评
        [TypesEvaluation.EVALUATION_UPDATE_EVALUATION](ctx, payload) {
            const questions = ctx.state.list.map(item => {
                let knowledgePoints = [];
                if (item.fromType === 1) {
                    knowledgePoints = item.knowledges ? item.knowledges.map(ele => ({id: ele.id, name: ele.name})) : [];
                }
                if (item.fromType === 2) {
                    knowledgePoints = item.relatedKnowledgePoints ? item.relatedKnowledgePoints : [];
                }
                let questionItem = {
                    id: item.id,
                    type: item.fromType,
                    knowledgePoints
                };
                if (item.fromType === 3) {
                    return Object.assign({}, questionItem, {
                        examId: item.examId, // 考试id
                        paperId: item.paperId, // 试卷id
                        gradeAverageScore: item.gradeAverageScore, // 年级得分率
                        manfenRate: item.manfenRate});
                }
                return questionItem;
            });
            // http://wiki.iyunxiao.com/pages/viewpage.action?pageId=357915930#hfsfd-teacher%E9%98%B6%E6%AE%B5%E6%B5%8B%E8%AF%84API-%E6%9B%B4%E6%96%B0%E6%B5%8B%E8%AF%84%E9%A2%98%E7%9B%AE
            return Vue.http.put(`/v1/stage-evaluation/${payload.id}/questions`, {questions})
                .then(resp => Vue.checkResp(resp))
                .then(data => {
                    return data;
                }).catch(err => {
                    throw err;
                });
        }
    }
};



// WEBPACK FOOTER //
// ./src/views/index/store/modules/modules_evaluation.js